import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/System/Reboot/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SystemPerm';
import RebootTable from 'components/Web_User_Interface/1440p_Series/System/Reboot/rebootTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "System Menü // System Reboot",
  "path": "/Web_User_Interface/1440p_Serie/System/Neustarten/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Nutzen Sie diese Funktion, um Ihre Kamera sicher neuzustarten. Es wird nicht empfohlen, einfach das Kabel ab- und wieder anzustecken (Diese Aktionen können sowohl für die laufenden Prozesse als auch für die interne SD-Karte schädlich sein). Bitte starten Sie immer über die Weboberfläche neu. Nutzen Sie den Hardware-Neustart nur, falls Sie die Weboberfläche nicht mehr erreichen können.",
  "image": "./WebUI_1440p_SearchThumb_System_Reboot.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_System_Reboot.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='System Menü // System Reboot' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Nutzen Sie diese Funktion, um Ihre Kamera sicher neuzustarten. Es wird nicht empfohlen, einfach das Kabel ab- und wieder anzustecken (Diese Aktionen können sowohl für die laufenden Prozesse als auch für die interne SD-Karte schädlich sein). Bitte starten Sie immer über die Weboberfläche neu. Nutzen Sie den Hardware-Neustart nur, falls Sie die Weboberfläche nicht mehr erreichen können.' image='/images/Search/WebUI_1440p_SearchThumb_System_Reboot.png' twitter='/images/Search/WebUI_1440p_SearchThumb_System_Reboot.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/System/Reboot/' locationFR='/fr/Web_User_Interface/1440p_Series/System/Reboot/' crumbLabel="System Reboot" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "system-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#system-men%C3%BC",
        "aria-label": "system menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`System Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/22a5b3342a0d752e8ecb84ac62ef889e/844cc/1440p_Settings_System_Restart.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "72.17391304347827%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACxElEQVQ4y5WT22sTWRzH80/YJkub3mzNzMRbmtomzW0mmSQzyZjMTCYmarVe6q1a22q7WfACoqCCry6roMLCsrAPyz6sguAVBPHyJIj/zUdm0rFWH8SHD+dw+PE533N+5wSi0SiSJHmIksTmoTDT1jxG52+0pfuoiz4PKC4+QD17j8alf0g3FugL9bB16zZSqRR9fX0MDQ0REH2ZKBIRBCJbtqDXWsycWGHf3BJ755bYd2wZZ/Y09oFTWDMncWbnKRsO8dguEok0yWSGyV1JxmMTBFyRi+DKIhEEQUIvazQbJo5dx7FNGmYNs2Zg1ndj6CV0TcNutKlUm2RSCpm0Qi5bIDGVJuAfd10ooutVWq0WzeYenGYT07SwzDo1o4JWrVCqm9jWQeqlNgVFRpHznnRqcvr7hKInrGBZdldk2VhmDefoKvbCDc6bba5oVRYdh+XZNoaRQ87KZNL5rlAQxQ0JRVFCK6u0WhpmvYxW1qhoZTTDRrf2crhRYaYkc3l+D5eWDGwrQy6TI5tRSCZcoSBsEEqi5BW0WzpmPY+alz0yqRRFOU2tmmd1dYH///2T6502ujrtJSzmZaaTyXWh1+U1YTolo6pFqhUFOZelVFDY36wzd+Qwd/64zZvXL/j06iWPb13FKudQcllv08TUmtC/R08oRcll86iFIlqpiJpXubiywH9//c7DJ8/58OEd75894uOLp7y9f5dzTR1FkSnIBZKJ1HpC/9gu47E4sZ1x4uMT6AWZlVOHWD5zkpXOr9y8doHfTh/n6sUOncV5WuoUkxPjxGJxtm/bsZ7Ql42OjhIOhxkY6NLf308wGPLo7ell06YeekMheoJBgqEQv/SHCYcH1uoHNj4bl7GxMe8Lfc3w8LDHyMhIF3/urn9TG/Ab0hVGvISDg4MbcAv98UcERCnqNcJ9j4IofUnop/oZmSv8DJmb5x43R5RRAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/22a5b3342a0d752e8ecb84ac62ef889e/e4706/1440p_Settings_System_Restart.avif 230w", "/de/static/22a5b3342a0d752e8ecb84ac62ef889e/d1af7/1440p_Settings_System_Restart.avif 460w", "/de/static/22a5b3342a0d752e8ecb84ac62ef889e/7f308/1440p_Settings_System_Restart.avif 920w", "/de/static/22a5b3342a0d752e8ecb84ac62ef889e/ff569/1440p_Settings_System_Restart.avif 1306w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/22a5b3342a0d752e8ecb84ac62ef889e/a0b58/1440p_Settings_System_Restart.webp 230w", "/de/static/22a5b3342a0d752e8ecb84ac62ef889e/bc10c/1440p_Settings_System_Restart.webp 460w", "/de/static/22a5b3342a0d752e8ecb84ac62ef889e/966d8/1440p_Settings_System_Restart.webp 920w", "/de/static/22a5b3342a0d752e8ecb84ac62ef889e/83135/1440p_Settings_System_Restart.webp 1306w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/22a5b3342a0d752e8ecb84ac62ef889e/81c8e/1440p_Settings_System_Restart.png 230w", "/de/static/22a5b3342a0d752e8ecb84ac62ef889e/08a84/1440p_Settings_System_Restart.png 460w", "/de/static/22a5b3342a0d752e8ecb84ac62ef889e/c0255/1440p_Settings_System_Restart.png 920w", "/de/static/22a5b3342a0d752e8ecb84ac62ef889e/844cc/1440p_Settings_System_Restart.png 1306w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/22a5b3342a0d752e8ecb84ac62ef889e/c0255/1440p_Settings_System_Restart.png",
              "alt": "Web User Interface - 1440p Series - System Reboot",
              "title": "Web User Interface - 1440p Series - System Reboot",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <RebootTable mdxType="RebootTable" />
    <EuiSpacer mdxType="EuiSpacer" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      